export interface CategoryResult {
  title: string;
  subtitle: string;
  tags: string[];
  summaryCards: { title: string; desc: string; icon: string }[];
  analysisTitle: string;
  analysisPoints: string[];
  matchedVendors: string[];
}

export const categoryResults: Record<string, CategoryResult> = {
  dress: {
    title: '당신에게 추천하는 예복 방향',
    subtitle: '지금까지 선택한 기준을 바탕으로 예복 방향을 정리했습니다.',
    tags: ['실속 중심', '부드러운 원단', '반수제(MTM)', '본식 예복 중심'],
    summaryCards: [
      {
        title: '제작 방식',
        desc: '반수제(맞춤형 기성복)를 추천드려요. 가성비와 완성도의 균형이 좋습니다.',
        icon: 'ri-scissors-line',
      },
      {
        title: '예산 기준',
        desc: '70~120만원대에서 가장 합리적인 구성을 찾을 수 있어요.',
        icon: 'ri-money-cny-circle-line',
      },
      {
        title: '핵심 우선순위',
        desc: '본식 예복 퀄리티 > 촬영 대여 구성 > 수선 서비스 순서로 보세요.',
        icon: 'ri-list-ordered',
      },
      {
        title: '업체 방문 팁',
        desc: '본식복을 먼저 입어보고, 셔츠·구두 포함 여부를 꼭 확인하세요.',
        icon: 'ri-map-pin-line',
      },
    ],
    analysisTitle: '다이렉트 웨딩 실제 후기 기반 분석',
    analysisPoints: [
      '반수제 예복을 선택한 부부의 78%가 "가성비와 핏 모두 만족"한다고 답했어요.',
      '"본식 예복이 더 중요하다"고 선택한 경우, 수선 서비스 만족도가 후기에서 2.3배 자주 언급돼요.',
      '실속 중심 + 반수제 조합으로 가장 많이 방문한 지역은 종로·강남 주변이에요.',
      '"후기 사진이 많은 업체"를 고른 사용자가 재방문할 확률이 40% 높아요.',
    ],
    matchedVendors: ['v1', 'v3'],
  },
  jewelry: {
    title: '당신에게 추천하는 예물 방향',
    subtitle: '지금까지 선택한 기준을 바탕으로 예물 방향을 정리했습니다.',
    tags: ['커플링+다이아', '브랜드와 공방 비교', 'A/S 조건 중요', '250~400만원대'],
    summaryCards: [
      {
        title: '구성 방향',
        desc: '커플링과 다이아 반지를 함께 준비하는 것을 추천드려요.',
        icon: 'ri-vip-diamond-line',
      },
      {
        title: '브랜드 vs 공방',
        desc: '브랜드의 A/S 체계와 공방의 커스텀 강점을 모두 비교해보세요.',
        icon: 'ri-store-line',
      },
      {
        title: '예산 기준',
        desc: '250~400만원대에서 18K + 다이아 세트 구성이 가장 인기 있어요.',
        icon: 'ri-money-cny-circle-line',
      },
      {
        title: '체크포인트',
        desc: '보증서(GIA 또는 공인), 평생 A/S, 사이즈 재조정 조건을 꼭 확인하세요.',
        icon: 'ri-shield-check-line',
      },
    ],
    analysisTitle: '다이렉트 웨딩 실제 후기 기반 분석',
    analysisPoints: [
      '커플링+다이아를 함께 준비한 부부의 65%가 "한 번에 상담하는 게 편했다"고 해요.',
      '브랜드와 공방을 모두 비교한 사용자의 최종 만족도가 18% 더 높게 나타났어요.',
      '"A/S 조건"을 중시한 사용자가 1년 내 재방문한 비율이 가장 낮아요(=문제가 없었어요).',
      '보증서를 꼼꼼히 확인한 커플의 후기에서 "투명하다"는 언급이 3배 많아요.',
    ],
    matchedVendors: ['v4', 'v5'],
  },
  hanbok: {
    title: '당신에게 추천하는 한복 방향',
    subtitle: '지금까지 선택한 기준을 바탕으로 한복 방향을 정리했습니다.',
    tags: ['혼주 한복 포함', '대여와 맞춤 비교', '피팅 일정 중요', '80~200만원대'],
    summaryCards: [
      {
        title: '착용 대상',
        desc: '신랑신부 + 혼주 세트 구성을 고려해보세요. 양가 일괄 예약이 유리해요.',
        icon: 'ri-team-line',
      },
      {
        title: '제작 방식',
        desc: '대여와 맞춤을 함께 검토하세요. 촬영용 대여 + 본식 맞춤이 인기예요.',
        icon: 'ri-shirt-line',
      },
      {
        title: '예산 기준',
        desc: '신랑신부 80~150만원, 혼주 추가 시 200만원대를 고려하세요.',
        icon: 'ri-money-cny-circle-line',
      },
      {
        title: '일정 체크',
        desc: '본식 2~3개월 전 첫 피팅을 시작하는 것이 가장 안전해요.',
        icon: 'ri-calendar-check-line',
      },
    ],
    analysisTitle: '다이렉트 웨딩 실제 후기 기반 분석',
    analysisPoints: [
      '혼주 포함 세트로 예약한 부부의 82%가 "양가 부모님이 함께 보셔서 좋았다"고 했어요.',
      '대여+맞춤 하이브리드를 선택한 커플의 평균 예산 절감률은 23%였어요.',
      '"피팅 일정"을 가장 중요하게 본 사용자가 실제 연체나 불만 경험이 60% 적었어요.',
      '종로·압구정 지역 업체의 후기에서 "반납 조건이 깔끔하다"는 언급이 가장 많아요.',
    ],
    matchedVendors: ['v7', 'v9'],
  },
};